import { authApiService } from '@/api/authApiService';
import { ApiParams } from '@/api/helpers/apiHelpers';
import { ChangeWireStatusType } from '@/bundle/_OrgAdmin/pages/OutboundWire/api/api';
import { ApiResponseType } from '@/types/sharedTypes';
import { AssignedWireType } from '@/types/wireTypes';

type DataType = {
  status: ChangeWireStatusType;
};

export const changeWireStatusApi = (
  id: string,
  data: DataType,
  params?: ApiParams
): Promise<ApiResponseType<AssignedWireType>> => {
  const uri = `/organization/wires/${id}/status/`;

  return authApiService.PATCH(uri, data, params);
};
